import script from "./workload-view-summary-errors.vue?vue&type=script&setup=true&lang=ts"
export * from "./workload-view-summary-errors.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__